import {AlertController, NavController, NavParams, LoadingController, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {CityUtil, ProvinceUtil} from "../../util/cityUtil";
import {PersonBankCardConfirmPage} from "../personBankCardConfirm/personBankCardConfirm";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    templateUrl: 'personBankCardAdd.html',
    selector: 'agency-user-bet-search-page',
})
export class PersonBankCardAddPage {
    //添加银行卡完成后是否清空
    static NeedInit: boolean = false;
    //开户支行名称
    nbranchname: string = "";
    nbankname: string = "";
    nprovince: string = "1";
    nprovinceText: string = "Việt Nam";
    ncity: string = "1";
    ncityText: string = "Việt Nam";
    nname: string;
    nbankcard: string;
    bankcard2: string;
    checkpwd: string;
    cityList: any = [];
    //省份
    shenList: any = ProvinceUtil;
    myGroup: FormGroup;

    public toggleIputOtherBank: boolean = false;
    public nbranchotherbank: string;


    constructor(private keyboard: Keyboard, public loadingCtrl: LoadingController, private nav: NavController, private alertCtrl: AlertController, private userService: UserService, public formBuilder: FormBuilder) {
        this.myGroup = formBuilder.group({
            nbankname: [''],
            nprovince: [''],
            ncity: [''],
            nbranchname: [''],
            nname: ['', Validators.required],
            nbankcard: ['', Validators.compose([Validators.maxLength(19), Validators.minLength(16), Validators.pattern('[0-9]*'), Validators.required])],
            bankcard2: ['', Validators.compose([Validators.maxLength(19), Validators.minLength(16), Validators.pattern('[0-9]*'), Validators.required])],
            checkpwd: ['', Validators.required],
            nbranchotherbank: ['']
        });
        //this.cityChange();
    }

    ionViewWillEnter() {
        PersonBankCardAddPage.NeedInit = false;
        this.nname = "";
        this.nbankcard = "";
        this.bankcard2 = "";
        this.checkpwd = "";
        this.nbranchotherbank = "";
    }

    nextFn() {
        if (this.nbankname.length < 1) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Thất Bại, Chưa chọn tên ngân hàng!`
            });
        } else if (this.nbranchname.length < 1 || this.nbranchname.length > 30) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Thất bại, Chi nhánh ngân hàng từ 2 đến 30 ki tự!"
            });
        } else if (this.nname.length < 1 || this.nname.length > 30) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Thất bại, Tên tài khoản ngân hàng từ 2 đến 30 ki tự!"
            });
        } else if (this.nbankcard.length < 1 || this.nbankcard.length > 25) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Thất bại, Số tài khoản ngân hàng từ 2 đến 30 ki tự!"
            });
        } else if (this.nbankcard != this.bankcard2) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Thất bại, Nhập lại số tài khoản chưa chính xác !"
            });
        } else if (this.checkpwd.length < 1) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Thất bại, Chưa nhập mật khẩu thanh toán !"
            });
        }else if (this.toggleIputOtherBank && (this.nbranchotherbank.length < 1 || this.nbranchotherbank.length > 51)) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Thất bại, Tên tài khoản ngân hàng từ 2 đến 50 ki tự!"
            });
        } else {
            let requestData: any = {
                nbankname: this.toggleIputOtherBank ? this.nbranchotherbank : this.nbankname,
                nprovince: this.nprovinceText,
                ncity: this.ncityText,
                nbranchname: this.nbranchname,
                nname: this.nname.trim().toLocaleUpperCase(),
                nbankcard: this.nbankcard,
                bankcard2: this.bankcard2,
                checkpwd: this.checkpwd
            };

            console.log(requestData.nname);

            this.userService.addBankcardCheck(requestData, this.alertCtrl).then(data => {
                if (!data["msg"]) {
                    this.nav.push(PersonBankCardConfirmPage, {
                        data: {
                            nbankname: this.toggleIputOtherBank ? this.nbranchotherbank : this.nbankname,
                            nbranchname: this.nbranchname,
                            nprovince: this.nprovinceText,
                            ncity: this.ncityText,
                            nname: this.nname.toLocaleUpperCase(),
                            nbankcard: this.nbankcard
                        }
                    });
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            });
        }
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }

    slectedBank(ev: any) {
        this.toggleIputOtherBank = false;
        if (this.nbankname === 'otherBank') {
            this.toggleIputOtherBank = true;
            this.nbranchotherbank = "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/personBankCardAdd/personBankCardAdd.ts